export default __webpack_public_path__ + "static/lawn-care-6abb26d2f32d4406ce3d6f2307225b18.webp";